import { API } from "@/api";

export async function downloadFile(path, filename, { method = "GET", body = null, headers = {} } = {}) {
  const token = localStorage.getItem("token");
  const h = { Authorization: `Bearer ${token}`, ...headers };
  const res = await fetch(`${API}${path}`, { method, headers: h, body });
  if (!res.ok) throw new Error("download failed");
  const blob = await res.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export async function uploadFile(path, file) {
  const token = localStorage.getItem("token");
  const fd = new FormData();
  fd.append("file", file, file.name);
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body: fd,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.detail || "upload failed");
  return data;
}
